import { COMPANY_USER_OK, COMPANY_USER_ERR } from "./company.action";

const InitState = {
  error: null,
  content: null,
};

export default function CompanyReducer(state = InitState, action) {
  switch (action.type) {
    case COMPANY_USER_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case COMPANY_USER_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    default:
      return state;
  }
}
